/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import {Icon, Button, Menu, Dropdown} from 'antd';
import {DmsTab, TableView, FilterBox} from 'Components';
/*import AjaxRequest from '../../utils/ajaxRequest';*/

class RegionList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['角色管理'],
			key: 0,
			filterBoxVisible: false,
			rows: [
				{
					id: 1,
					name: '系统管理员',
					code: 'admin',
					active: 1,
					description:'系统设置与管理'
				}, {
					id: 2,
					name: '品牌商',
					code: 'BM',
					active: 1,
					description:'品牌商'
				}, {
					id: 3,
					name: '订货端',
					code: 'CO',
					active: 1,
					description:'渠道商'
				},{
					id: 4,
					name: '零售端',
					code: 'SR',
					active: 1,
					description:'零售门店'
				}
			],
			total: 2,
			searchObj: {
				name: '',
				code: '',
				active:'',
				pageSize: 10,
				pageNo: 1
			}
		};

		this.pageChange = this.pageChange.bind(this);
		this.visibleChange = this.visibleChange.bind(this);
		this.setFilterParam = this.setFilterParam.bind(this);
		this.advanceReset = this.advanceReset.bind(this);
		this.advanceSubmit = this.advanceSubmit.bind(this);
		this.dropdownClick = this.dropdownClick.bind(this);
		this.goView=this.goView.bind(this);
	}

	//页面跳转
	goView (url) {
		hashHistory.push(url);
	}

	visibleChange() {
		this.setState({filterBoxVisible: !this.state.filterBoxVisible});
	}

	advanceReset() {
		console.log('advanceReset');
		this.setState({
			searchObj: {
				...this.state.searchObj,
				name: '',
				code: '',
				active:''
			}
		})
	};

	advanceSubmit(form) {
		console.log('advanceSubmit')
	};

	setFilterParam(name, value) {
		// console.log(name + ':\t' + value);
		this.setState({searchObj: {...this.state.searchObj, [name]: value}});
	};

	pageChange(page, pageSize) {
		this.setState({searchObj: {...this.state.searchObj, pageSize, pageNo: page}})
	}

	dropdownClick({item, key, keyPath}) {
		var arr = key.split('_');
		if (arr[0] === '0') {
			var data = this.state.rows;
			if(data[arr[1]].active ===1){
				data[arr[1]].active = 0;
			}else{
				data[arr[1]].active = 1;
			}
			this.setState({
				rows: data
			})
		}
		;
		if (arr[0] === '1') {
			this.state.rows.splice(arr[1], 1);
			this.setState({
				rows: this.state.rows
			})
		}
		;
	}

	menu(index) {
		return <Menu style={{width: "100px", textAlign: 'center', left: '-50px'}} onClick={this.dropdownClick}>
			<Menu.Item key={`1_${index}`}>
				{
					this.state.rows[index].active===1?
						'禁用'
						:
						'启用'
				}
			</Menu.Item>
			<Menu.Item key={`2_${index}`}>
				删除
			</Menu.Item>
		</Menu>
	}

	render() {
		const {opts, filterBoxVisible, rows, total, searchObj} = this.state;
		const filterBoxProps = {
			showFlag: filterBoxVisible,
			advance: {
				fileds: [
					{
						name: 'name',
						label: '角色名称',
						text: '请输入角色名称',
						type: 'default'
					},
					{
						name: 'code',
						label: '角色编码',
						text: '请输入角色编码',
						type: 'default'
					},
					{
						name: 'active',
						label: '有效性',
						text: "全部",
						options: [
							{value: '1', text: '有效'},
							{value: '0', text: '无效'},
							{value: '2', text: '全部'},
						],
						type: 'select'
					}
				],
				handle: this.advanceSubmit,
				reset: this.advanceReset,
				fieldHandle: this.setFilterParam
			}
		};
		const tableViewProps = {
			loading: false,//更新表格数据中
			rowKey: 'id',
			pageParam: {
				total,
				current: searchObj.pageNo,//当前页码
				pageSize: searchObj.pageSize,//当前分页数
				onChange: this.pageChange
			},
			columns: [{
				title: '角色',
				dataIndex: 'name',
				render: (text, record, index) => <a href={`#/role/roleadd/${record.id}`}>{text}</a>
			}, {
				title: '编码',
				dataIndex: 'code',
			},{
				title: '描述',
				dataIndex: 'description',
			}, {
				title: '状态',
				dataIndex: 'active',
				render: text => text === 1 ? <span style={{color: 'green'}}>有效</span> :
					<span style={{color: '#d61518'}}>无效</span>
			},
				{
					title: '更多操作',
					key: 'action',
					render: (text, record, index) => (
						<Dropdown overlay={this.menu(index)} trigger={['click']}>
							<span className="ant-dropdown-link">
								<Icon type="caret-down"/>
							</span>
						</Dropdown>
					)
				}],
			rows
		};
		return (
			<div className='dms-body'>
				<div>
					<DmsTab options={opts} defaultKey={0} onChange={this.changeHandle}>
						<Button icon="plus" onClick={this.goView.bind(this, '/role/roleadd/0')}>新增</Button>
						<Button icon="filter" onClick={this.visibleChange}>筛选</Button>
						<FilterBox  {...filterBoxProps}/>
					</DmsTab>
				</div>

				<div className="dms-table-box">
					<TableView {...tableViewProps} />
				</div>
			</div>
		)
	}
}
;
export default RegionList;



// WEBPACK FOOTER //
// ./src/routes/role/list.js